export var HierarchyExternalIdTypesEnum;
(function (HierarchyExternalIdTypesEnum) {
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_0"] = 0] = "NUMBER_0";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_1"] = 1] = "NUMBER_1";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_2"] = 2] = "NUMBER_2";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_3"] = 3] = "NUMBER_3";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_4"] = 4] = "NUMBER_4";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_5"] = 5] = "NUMBER_5";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_6"] = 6] = "NUMBER_6";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_7"] = 7] = "NUMBER_7";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_8"] = 8] = "NUMBER_8";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_9"] = 9] = "NUMBER_9";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_10"] = 10] = "NUMBER_10";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_11"] = 11] = "NUMBER_11";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_12"] = 12] = "NUMBER_12";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_13"] = 13] = "NUMBER_13";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_14"] = 14] = "NUMBER_14";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_15"] = 15] = "NUMBER_15";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_16"] = 16] = "NUMBER_16";
    HierarchyExternalIdTypesEnum[HierarchyExternalIdTypesEnum["NUMBER_17"] = 17] = "NUMBER_17";
})(HierarchyExternalIdTypesEnum || (HierarchyExternalIdTypesEnum = {}));
HierarchyExternalIdTypesEnum['NUMBER_0'] = 0;
HierarchyExternalIdTypesEnum['NUMBER_1'] = 1;
HierarchyExternalIdTypesEnum['NUMBER_2'] = 2;
HierarchyExternalIdTypesEnum['NUMBER_3'] = 3;
HierarchyExternalIdTypesEnum['NUMBER_4'] = 4;
HierarchyExternalIdTypesEnum['NUMBER_5'] = 5;
HierarchyExternalIdTypesEnum['NUMBER_6'] = 6;
HierarchyExternalIdTypesEnum['NUMBER_7'] = 7;
HierarchyExternalIdTypesEnum['NUMBER_8'] = 8;
HierarchyExternalIdTypesEnum['NUMBER_9'] = 9;
HierarchyExternalIdTypesEnum['NUMBER_10'] = 10;
HierarchyExternalIdTypesEnum['NUMBER_11'] = 11;
HierarchyExternalIdTypesEnum['NUMBER_12'] = 12;
HierarchyExternalIdTypesEnum['NUMBER_13'] = 13;
HierarchyExternalIdTypesEnum['NUMBER_14'] = 14;
HierarchyExternalIdTypesEnum['NUMBER_15'] = 15;
HierarchyExternalIdTypesEnum['NUMBER_16'] = 16;
HierarchyExternalIdTypesEnum['NUMBER_17'] = 17;
//# sourceMappingURL=HierarchyExternalIdTypesEnum.js.map